import * as globals from '@wandb/weave/common/css/globals.styles';
import React, {FC, useCallback} from 'react';
import styled, {css} from 'styled-components';

import {useBetaFeatureNightModeEnabled} from '../../util/useBetaFeature';
import {NightAwareProps} from './types';
import {MOBILE_BREAKPOINT_PX} from './utils';

type SearchModalProps = {
  onClose: () => void;
};

export const SearchModal: FC<SearchModalProps> = ({onClose, children}) => {
  const isNightMode = useBetaFeatureNightModeEnabled();
  const onDimmerClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose]
  );
  return (
    <Dimmer isNightMode={isNightMode} onClick={onDimmerClick}>
      <Dialog isNightMode={isNightMode}>{children}</Dialog>
    </Dimmer>
  );
};

const Dimmer = styled.div.attrs({
  className: `night-aware-exclude-children`,
})<NightAwareProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${p =>
    globals.hexToRGB(globals.OBLIVION, !p.isNightMode ? 0.16 : 0.64)};
  z-index: 2147483605; // Stolen from semantic-ui-react's dimmer

  padding: min(15vh, 160px) 24px;
  @media (max-width: ${MOBILE_BREAKPOINT_PX}px) {
    padding: 0;
  }
`;

const dialogStyles = css<NightAwareProps>`
  ${p =>
    !p.isNightMode
      ? css`
          background-color: ${globals.WHITE};
        `
      : css`
          background-color: ${globals.MOON_900};
        `}
`;

const Dialog = styled.div.attrs({
  className: `night-aware-exclude-children`,
})<NightAwareProps>`
  ${dialogStyles}
  position: relative;
  display: flex;
  max-height: 100%;

  box-shadow: ${p =>
    !p.isNightMode
      ? globals.MODAL_SHADOW_LIGHT_MODE
      : globals.MODAL_SHADOW_NIGHT_MODE};
  ${p => p.isNightMode && `border: 1px solid ${globals.MOON_800};`}
  width: min(100%, 600px);
  border-radius: 8px;
  padding: ${p => (!p.isNightMode ? 24 : 22)}px;
  @media (max-width: ${MOBILE_BREAKPOINT_PX}px) {
    border-radius: 0;
    width: 100%;
    padding: 24px;
    border: none;
    box-shadow: none;
    height: 100%;
  }
`;
